import { Uuid } from "@/domains/global/identifiers";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind, SyncUpdateValue } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import {
  SpaceAccountSettingsModelData,
  SpaceAccountSettingsPayload,
  VoiceSettings,
} from "@/store/space-account-settings/types";

export class SpaceAccountSettingsModel extends BaseSyncModel<SpaceAccountSettingsModelData> {
  public modelKind = SyncModelKind.SpaceAccountSettings;

  constructor({
    id,
    data,
    store,
  }: { id: Uuid; data: SyncUpdateValue<SpaceAccountSettingsModelData> } & WithAppStore) {
    super({ id, data, store });
  }

  get ownedBySpaceAccountId(): string {
    return this.modelData.owned_by_space_account_id;
  }

  get settings(): SpaceAccountSettingsPayload {
    return this.modelData.settings;
  }

  get voiceSettings(): VoiceSettings | undefined {
    return this.modelData.settings.voice;
  }

  get customVocabulary(): string[] {
    return this.voiceSettings?.custom_vocabulary ?? [];
  }

  get processingInstructions(): string {
    return this.voiceSettings?.processing_instructions ?? "";
  }
}
